import { render, staticRenderFns } from "./testWindow.vue?vue&type=template&id=1ac1b000&scoped=true"
import script from "./testWindow.vue?vue&type=script&lang=js"
export * from "./testWindow.vue?vue&type=script&lang=js"
import style0 from "./testWindow.vue?vue&type=style&index=0&id=1ac1b000&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac1b000",
  null
  
)

export default component.exports